import template from "./font-style-changer.html";

const FontStyleChangerComponent = {
  bindings: {
    model: "=",
    onApplyCustomStyleToQuote: "&",
    onChange: "&",
  },
  template: template,
  controller: class FontStyleChangerController {
    /* @ngInject */
    constructor($rootScope, $scope) {
      this.$rootScope = $rootScope;
      this.$scope = $scope;
    }

    $onInit() {
      this.brandCenterSync = this.model.brandCenterSync;

      if (this.brandCenterSync === true) {
        this.currentElementName = null;
        this.currentElement = null;
      } else {
        this.currentElementName = "header1";
        this.currentElement = angular.copy(this.model.style.header1);
      }

      this.$scope.$watch(
        () => this.brandCenterSync,
        (newVal, oldVal) => {
          if (newVal !== oldVal) {
            this.model.brandCenterSync = newVal;
            if (this.brandCenterSync === true) {
              this.model.style.header1 = this._resettedStyle();
              this.model.style.header2 = this._resettedStyle();
              this.model.style.text = this._resettedStyle();
              this.currentElementName = null;
              this.currentElement = null;
            } else {
              this.model.style.header1 = this._getDefaultOrganizationStyle("header1");
              this.model.style.header2 = this._getDefaultOrganizationStyle("header2");
              this.model.style.text = this._getDefaultOrganizationStyle("text");
              this.currentElementName = "header1";
              this.currentElement = angular.copy(this.model.style.header1);
            }
            this.onChange();
          }
        },
      );
    }

    changeElement(element, elementName) {
      this.currentElementName = elementName;
      this.currentElement = angular.copy(element);
    }

    changeFont(font) {
      this.currentElement.font = font;
      this.model.style[this.currentElementName] = this.currentElement;
      this.onChange();
    }

    changeColor(color) {
      this.currentElement.color = color;
      this.model.style[this.currentElementName] = this.currentElement;
      this.onChange();
    }

    changeFontSize(size) {
      this.currentElement.size = size;
      this.model.style[this.currentElementName] = this.currentElement;
      this.onChange();
    }

    _resettedStyle() {
      return { font: {}, size: null, color: null };
    }

    _getDefaultOrganizationStyle(element) {
      return {
        font: this.$rootScope.organization.branding[element].font,
        size: this.$rootScope.organization.branding[element].size,
        color: this.$rootScope.organization.branding[element].color,
      };
    }
  },
};

export default FontStyleChangerComponent;
